const initVideo = (videoEl, options = {}) => {
	if (options.targetAspectRatio !== 'auto') {
		videoEl.addEventListener('loadedmetadata', () => {
			const videoAspectRatio = videoEl.videoWidth / videoEl.videoHeight;
			const [ta, tb] = options.targetAspectRatio.split('/');
			const targetAspectRatio = tb
				? parseFloat(ta) / parseFloat(tb)
				: parseFloat(ta);
			const widthPercent =
				Math.round((videoAspectRatio / targetAspectRatio) * 10_000) /
				100;
			options.mediaWrapperEl.style.setProperty(
				'--media-video-correction',
				`${widthPercent}%`
			);
		});
	}
};

const initMedia = (mediaWrapperEl) => {
	const mediaEl = mediaWrapperEl.querySelector('.ona-media__media');
	if (mediaEl && mediaEl.tagName === 'VIDEO') {
		initVideo(mediaEl, {
			mediaWrapperEl,
			targetAspectRatio: mediaWrapperEl.style.getPropertyValue(
				'--media-aspect-ratio'
			),
		});
	}
};

document
	.querySelectorAll('.ona-media')
	.forEach((mediaEl) => initMedia(mediaEl));
